import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { AutomationTriggersComponent } from './triggers.component';
import { AutomationTriggerDirective } from './triggers.directive';
import { OnAttributeChangeTriggerComponent } from './on-attribute-change/on-attribute-change.component';
import { OnObjectCreatedTriggerComponent } from './on-object-created/on-object-created.component';

@NgModule({
  declarations: [
    AutomationTriggersComponent,
    AutomationTriggerDirective,
    OnAttributeChangeTriggerComponent,
    OnObjectCreatedTriggerComponent,
  ],
  imports: [CommonModule, FormsModule, MatSelectModule],
  exports: [AutomationTriggersComponent],
})
export class AutomationTriggersModule {}
